<template>
  <div
    :class="`
      ${color}
      waggon-info-header
    `"
    :style="`width: ${width};
    ${cursor?`cursor: ${cursor}`:''};
    color: ${textcolor};
    `"
    >
    <TIcon
      v-if="getNewIcon(icon)"
      :name="getNewIcon(icon)"
      medium
      :color="textcolor ? textcolor : 'black'"
    />
    <div
      class="font-weight-light mr-1">
      {{text}} <span v-if="wp_part && wp_part !== 1">[{{wp_part}}]</span>
    </div>
    <div v-if="selected && taktarea_name"
      class="font-weight-light mr-1">
      ({{taktarea_name}})
    </div>
    <v-spacer/>
    <slot/>
  </div>
</template>
<script>
import {
  mapGetters,
 } from 'vuex';
import TIcon from '@/components/Taktify/TIcon.component.vue';
export default {
  components: {
    TIcon,
  },
  props: ['width', 'color', 'text', 'icon', 'selected', 'cursor', 'taktarea_name', 'wp_part', 'textcolor'],
  computed: {
    ...mapGetters('TWorkPackage', [
      'isStandardIcon'
      ],
    ),
    ...mapGetters('WorkPackage', [
      'getNewIcon',
      ]
    ),
  }
}
</script>
<style>
  .waggon-info-header {
    display: flex;
    height: 35px;
    border-radius: 3px 3px 0px 0px;
    line-height: 35px;
    transition: width 200ms ease-in-out;
    user-select: none;
    cursor: pointer;
    overflow: hidden;
    align-items: center;
    justify-content: center;
  }
</style>
